import React from 'react';
import { observer } from 'mobx-react-lite';
import GameReportScene from './gameReportScene';
import GameFinishScene from './gameFinishScene';
import GameKickScene from './gameKickScene';
import GameStartScene from './gameStartScene';

const GameActiveVideoScene = observer(() => {
  return (
    <>
      <GameStartScene />
      <GameKickScene />
      <GameReportScene />
      <GameFinishScene />
    </>
  );
});

export default GameActiveVideoScene;
